import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { TranslateModule } from "@ngx-translate/core";
import { TaskListButtonComponent } from "./task-list-button.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        IonicModule
    ],
    declarations: [
        TaskListButtonComponent
    ],
    exports: [
        TaskListButtonComponent
    ]
})
export class TaskListButtonModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/task-list-button/task-list-button.module.ts